import listaMenu from '@/api/menu'

export default {
  layout: 'loading', // loading, admin, blank
  theme: localStorage.getItem(process.env.VUE_APP_CLIENT_ID + '-theme') || '',
  sidebar: '',
  menu: listaMenu.intens,
  menuOriginal: []
}
